module.exports = __webpack_public_path__ + "ring-blueprint-deep.efda0e552124166a4ad6.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/ring-blueprint-deep.svg
// module id = ../../../../../src/assets/img/ring-blueprint-deep.svg
// module chunks = main